import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { togglePafta, PAFTA_OPTIONS } from '../../../redux/projectTabsSlice';
import './FileMenu.css';

const FileMenu = ({ onImport, onExport, onShare, onExampleSelect, onOpen, onSave, onSaveAs, onOpenProject, isSaving, isShareMode }) => {
  const dispatch = useDispatch();
  const enabledPaftaIds = useSelector((state) => state.projectTabs.enabledPaftaIds);
  const paftaOptions = useSelector((state) => state.projectTabs.paftaOptions);

  const displayPaftaOptions = paftaOptions || PAFTA_OPTIONS;

  const handleShare = () => {
    if (typeof onShare === 'function') onShare();
    else alert('Paylaş özelliği yakında geliyor.');
  };

  const handleExampleClick = (idx) => {
    if (typeof onExampleSelect === 'function') onExampleSelect(idx);
    else alert(`Örnek seçildi: örnek-${idx}`);
  };

  return (
    <div className="file-menu">

      {!isShareMode && (
        <>
          <div className="file-menu-item" onClick={onImport}>
            DXF Aç
          </div>

          <div className="file-menu-item" onClick={onOpenProject}>
            Proje Aç
          </div>

          <div className="file-menu-sep" />

          <div className={`file-menu-item${isSaving ? ' disabled' : ''}`} onClick={!isSaving ? onSave : undefined}>
            {isSaving ? 'Kaydediliyor...' : 'Kaydet'}
          </div>

          <div className="file-menu-item" onClick={onSaveAs}>
            Farklı Kaydet
          </div>

          <div className="file-menu-sep" />
        </>
      )}

      <div className="file-menu-item has-submenu">
        Pafta Seçimi ▶
        <div className="file-submenu file-pafta-submenu">
          {displayPaftaOptions.map((opt) => (
            <label
              key={opt.id}
              className="file-pafta-option"
              onClick={(e) => e.stopPropagation()}
            >
              <input
                type="checkbox"
                checked={enabledPaftaIds.includes(opt.id)}
                onChange={() => dispatch(togglePafta(opt.id))}
              />
              <span>{opt.label}</span>
            </label>
          ))}
        </div>
      </div>

      {!isShareMode && (
        <>
          <div className="file-menu-sep" />

          <div className="file-menu-item has-submenu">
            Örnekler ▶
            <div className="file-submenu file-examples">
              {[1,2,3,4,5,6,7].map(i => (
                <div key={i} className="file-submenu-item" onClick={() => handleExampleClick(i)}>
                  örnek-{i}
                </div>
              ))}
            </div>
          </div>

          <div className="file-menu-item share" onClick={handleShare}>
            Paylaş
          </div>
        </>
      )}

      <div className="file-menu-item" onClick={onExport}>
        DXF Disa Aktar
      </div>
    </div>
  );
};

export default FileMenu;
